import React, { useContext } from 'react';
import { AgendaContext } from '../../contexts/AgendaContext';
import { useTheme } from '@emotion/react';
// Mui components
import { Box, Button } from '@mui/material';
// Components
import DotLoader from '../common/Loaders/DotLoader/DotLoader';

function FooterSolicitudDeConexion({
  errorInFechaPublicacion,
  onHandleBack,
  onHandleNext,
  activeStep,
  stepHandler,
  setStepHandler,
  setActiveStep,
  loader
}) {
  const theme = useTheme();
  const { solicitudProps } = useContext(AgendaContext);

  const diabledButtonContinue = () => {
    if (activeStep === 0 && solicitudProps.proveedor != undefined) {
      return false;
    }
    if (
      activeStep === 1 &&
      solicitudProps.consultorioOsde != undefined &&
      solicitudProps.consultorioExterno
    ) {
      return false;
    }
    if (activeStep === 2 && solicitudProps?.especializacion?.some(
      especializacion => especializacion.solicitada === true)) {
      return false;
    }
    if (
      activeStep === 3 &&
      solicitudProps?.fechaPublicacion != null &&
      errorInFechaPublicacion === null
    ) {
      return false;
    }
    if (activeStep === 4) {
      return false;
    } else {
      return true;
    }
  };

  const handleNavigateEdit = () => {
    if (stepHandler === 'goStayAndReturn' && activeStep === 1) {
      setActiveStep(2);
      setStepHandler('goAndReturn');
    }
    if (stepHandler === 'goAndReturn' && (activeStep === 2 || activeStep === 3)) {
      setActiveStep(4);
      setStepHandler(null);
    }
  };

  const labelButton = () => {
    if (activeStep === 4) {
      return 'Enviar';
    }
    if (stepHandler === null || stepHandler === 'goStayAndReturn') {
      return 'Continuar';
    } else {
      return 'Guardar cambios';
    }
  };


  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        bottom: 0,
        position: 'sticky',
        width: '100%',
        height: '7em',
        paddingY: '2em',
        paddingX: '4rem',
        gap: 2,
        bgcolor: '#FFF'
      }}>
      <Button
        variant="outlined"
        onClick={() => onHandleBack()}
        disabled={loader}
        sx={{ display: 'flex', width: '20%', maxWidth: '220px' }}>
        Volver
      </Button>
      <Button
        variant="contained"
        onClick={stepHandler === null ? () => onHandleNext() : () => handleNavigateEdit()}
        disabled={diabledButtonContinue() || loader}
        sx={{
          display: 'flex',
          width: '20%',
          maxWidth: '220px',
          '&.Mui-disabled': {
            backgroundColor: loader ? theme.palette.darkBlue.main : ''
          }
        }}>
        {labelButton()}
        {loader && (
          <Box sx={{ position: 'absolute', right: '1rem' }}>
            <DotLoader size="7px" />
          </Box>
        )}
      </Button>
    </Box>
  );
}

export default FooterSolicitudDeConexion;
